<template>
  <vx-card :title="title">
    <div class="vx-row mb-2" style="width: 50%">
      <div class="vx-col sm:w-1/4 w-full flex items-center">
        <span>Shipment Date</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full whitespace-no-wrap">
        <div class="mt-4 flex justify-between">
          <date-range-picker
            style="min-height: 40px"
            class="w-full"
            ref="picker"
            opens="center"
            :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
            :singleDatePicker="false"
            :timePicker="false"
            :timePicker24Hour="false"
            :showWeekNumbers="false"
            :showDropdowns="false"
            :autoApply="true"
            v-model="shipmentDate"
            :linkedCalendars="true"
          >
            <template v-slot:input="picker" style="min-width: 350px">
              {{ globalDateFormat(picker.startDate) }} -
              {{ globalDateFormat(picker.endDate) }}
            </template>
          </date-range-picker>
          <vs-button
            class="ml-4"
            color="danger"
            icon-pack="feather"
            icon="icon-x"
            @click="
              () => {
                this.shipmentDate = { startDate: null, endDate: null };
              }
            "
          ></vs-button>
          <!-- <template>
              <vx-tooltip text="reset">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  @click.stop="handleResetInvoiceDateFilter()"
                />
              </vx-tooltip>
            </template> -->
        </div>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/4 w-full flex items-center">
        <span>Territory</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <territory-filter
          :showTitle="false"
          :full="true"
          :multiSelect="true"
          :disableOptionAll="disableOptionAll"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/4 w-full flex items-center">
        <span>Warehouse</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <multiselect
          v-model="warehouse.selected"
          :options="warehouse.options"
          placeholder="Type to search"
          track-by="warehouse_id"
          label="warehouse_name"
          :max-height="125"
          :multiple="true"
          :close-on-select="false"
        >
          <span slot="noResult">Oops! No data found</span>
          <template slot="tag" slot-scope="props">
            <span class="multiselect__tag">
              <span
                >{{ props.option.warehouse_code }}
                {{ props.option.warehouse_name }}</span
              >
              <i
                class="multiselect__tag-icon"
                @click="props.remove(props.option)"
              ></i>
            </span>
          </template>

          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title"
                >{{ props.option.warehouse_code }}
                {{ props.option.warehouse_name }}</span
              >
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <div>
      <div class="vx-row mb-6" style="width: 50%">
        <div class="vx-col sm:w-1/4 w-full flex items-center">
          <span>Type Report</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <multiselect
            v-model="type.selected"
            :options="type.options"
            placeholder="Type to search"
            track-by="type_name"
            label="type_name"
            :max-height="125"
          >
            <span slot="noResult">Oops! No data found</span>
            <template slot="singleLabel" slot-scope="props">
              <span class="option__desc">
                <span class="option__title">{{ props.option.type_name }}</span>
              </span>
            </template>

            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.type_name }}</span>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/4 w-full"></div>
      <div class="vx-col sm:w-3/4 w-full flex">
        <vs-button color="success" @click="handleExportExcel"
          >Export Excel</vs-button
        >
        <vs-button
          class="ml-4"
          color="primary"
          @click="$refs.tableExport.getData()"
          >Refresh Table</vs-button
        >
      </div>
    </div>
    <TableExport
      ref="tableExport"
      :warehouseID="warehouseID"
      :warehouseIDAll="warehouseIDAll"
      :warehouseCode="warehouseCode"
      :dateStart="shipmentDate.startDate"
      :dateEnd="shipmentDate.endDate"
      :type="type.selected"
      :whIDs="warehouseAll"
      :warehouseCodeAll="warehouseCodeAll"
    ></TableExport>
  </vx-card>
</template>
<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import TableExport from "./tab/DataTableExport.vue";
import territoryFilter from "../../../../components/operatingUnitFilter/territoryFilter.vue";

import Vue from "vue";
export default {
  components: {
    DateRangePicker,
    TableExport,
    territoryFilter,
  },
  data() {
    return {
      tab: 0,
      title: "Shipment Planning",
      baseUrl: "/api/v1/report/shipment-planning",
      table: this.tableState(),
      warehouse: {
        selected: [],
        options: [],
      },
      warehouseID: null,
      warehouseIDAll: null,
      warehouseCode: "",
      territoryIds: [],
      warehouseAll: [],
      warehouseCodeAll: "",
      shipmentDate: {
        startDate: "",
        endDate: "",
      },
      destroy: null,
      type: {
        selected: {
          type_name: "Shipment Plan",
          type_id: 1,
          value: "shipment-plan",
        },
        options: [
          { type_name: "Shipment Plan", type_id: 1, value: "shipment-plan" },
          {
            type_name: "Shipment Plan Line",
            type_id: 2,
            value: "shipment-plan-lines",
          },
        ],
      },
    };
  },
  methods: {
    handleExportExcel() {
      if (!this.shipmentDate.startDate || !this.shipmentDate.endDate) {
        this.$vs.notify({
          title: "Error",
          text: "Please select date first",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.warehouse.selected || this.warehouse.selected.length === 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please select warehouse first",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      this.$refs.tableExport.handleExport("excel");
    },
    dateFormat(date) {
      if (date) {
        return moment(String(date)).utcOffset(0).format("YYYY-MM-DD");
      }
    },
    tableState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "",
        sort: "",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    getAllDataTerritoryArea() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/territory", {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.territory.options = resp.data.records;
            if (this.territory.options.length > 0) {
              this.territory.selected = this.territory.options[0];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    getAllDataWarehouseByTerritory() {
      const territory_id = Vue.prototype.$store.state.user.currentUser
        ? Vue.prototype.$store.state.user.currentUser.territory_id
        : 0;

      const selectedTerritories =
        this.$store.state.operatingUnit.filter.selectedTerritories;

      const hasAll = selectedTerritories.some((t) => t.TerritoryID === 0);
      if (hasAll) {
        // "All" selected — use all territory IDs
        this.territoryIds = this.$store.state.operatingUnit.filter.territory
          .map((item) => item.TerritoryID)
          .filter((id) => id !== undefined && id !== null && id !== 0);
      } else {
        this.territoryIds = selectedTerritories
          .map((item) => item.TerritoryID)
          .filter((id) => id !== undefined && id !== null && id !== 0);
      }

      console.log(
        "territoryIds in getAllDataWarehouseByTerritory:",
        this.territoryIds
      );

      if (this.territoryIds.length === 0) {
        this.warehouse.options = [];
        this.warehouse.selected = [];
        this.warehouseAll = [];
        return;
      }

      this.$vs.loading();
      this.$http
        .get("/api/v1/master/warehouse-territory/options", {
          params: {
            order: "id",
            sort: "asc",
            territory_ids: this.territoryIds,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.warehouse.options = resp.data;
            if (territory_id === 0) {
              this.warehouse.options.unshift({
                warehouse_id: 0,
                warehouse_code: "All",
                warehouse_name: "",
              });
            }

            // if (this.warehouse.options.length > 1) {
            //   this.warehouse.selected = [this.warehouse.options[1]];
            // } else if (this.warehouse.options.length === 1) {
            //   this.warehouse.selected = [this.warehouse.options[0]];
            // }
            console.log("warehouse.options", this.warehouse.options);
            this.warehouseAll = this.warehouse.options.map(
              (w) => w.warehouse_id
            );
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
  },
  mounted() {
    this.$store.commit("operatingUnit/setSelectedTerritories", []);
  },
  watch: {
    "warehouse.selected": function (v, oldV) {
      if (v && v.length > 0) {
        const hasAll = v.some((w) => w.warehouse_id === 0);
        const oldHadAll = oldV && oldV.some((w) => w.warehouse_id === 0);

        if (hasAll && !oldHadAll) {
          // User just selected "All" — remove specific warehouses
          this.$nextTick(() => {
            this.warehouse.selected = v.filter((w) => w.warehouse_id === 0);
          });
          this.warehouseID = 0;
          this.warehouseCode = "All";
          this.warehouseIDAll = this.warehouse.options
            .filter((w) => w.warehouse_id !== 0)
            .map((w) => w.warehouse_id);
          this.warehouseCodeAll = "All";
        } else if (hasAll && oldHadAll && v.length > 1) {
          // "All" was already selected and user added a specific warehouse — remove "All"
          this.$nextTick(() => {
            this.warehouse.selected = v.filter((w) => w.warehouse_id !== 0);
          });
        } else if (!hasAll) {
          if (v.length === 1) {
            this.warehouseID = v[0].warehouse_id;
            this.warehouseCode = v[0].warehouse_code;
            this.warehouseIDAll = [];
            this.warehouseCodeAll = v[0].warehouse_code;
          } else {
            this.warehouseID = 0;
            this.warehouseCode = v.map((w) => w.warehouse_code).join(", ");
            this.warehouseIDAll = v.map((w) => w.warehouse_id);
            //set to warehouseCodeAll sample "D3501-D2403..."
            this.warehouseCodeAll = v.map((w) => w.warehouse_code).join("-");
          }
        }
      } else {
        this.warehouseID = null;
        this.warehouseCode = "";
        this.warehouseIDAll = [];
      }
    },
    "type.selected": function () {},
  },
  beforeDestroy() {
    this.destroy();
  },
  created() {
    this.destroy = this.$store.watch(
      (state) => state.operatingUnit.filter.selectedTerritories,
      () => {
        this.warehouse.selected = [];
        this.getAllDataWarehouseByTerritory();
      }
    );
  },
  computed: {
    disableOptionAll() {
      const territory_id = Vue.prototype.$store.state.user.currentUser
        ? Vue.prototype.$store.state.user.currentUser.territory_id
          ? true
          : false
        : false;
      console.log("disableOptionAll, territoryId:", territory_id);
      return territory_id;
    },
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        if (val != this.table.page) {
          this.handleChangePage(val);
        }
      },
    },
    // selectedTerritoryId() {
    //   return this.$store.getters["operatingUnit/getSelectedTerritoryId"];
    // },
  },
};
</script>
